import { Navigate, Route, Routes } from "react-router-dom";
import PermissionDeniedPage from "../PermissionDeniedPage";
import BdcImportPage from "../../pages/BdcImportPage";
import BdcQueuePage from "../../pages/BdcQueuePage";
import BdcShipmentPage from "../../pages/BdcShipmentPage";
import BdcSettingsPage from "../../pages/BdcSettingsPage";
import BdcStockDayPage from "../../pages/BdcStockDayPage";
import BdcDispatchPage from "../../pages/BdcDispatchPage";
import BdcDocumentsPage from "../../pages/BdcDocumentsPage";
import BdcInvoicesPage from "../../pages/BdcInvoicesPage";
import BdcEdiPage from "../../pages/BdcEdiPage";
import BdcCreditNotesPage from "../../pages/BdcCreditNotesPage";
import BdcCreditNotePage from "../../pages/BdcCreditNotePage";
import BdcDashboardPage from "../../pages/BdcDashboardPage";
import BdcDashboardStoresPage from "../../pages/BdcDashboardStoresPage";
import { BDC_DASHBOARD_PATH, BDC_DASHBOARD_STORES_PATH } from "./Dashboard/constants";
import {
  BDC_CREDIT_NOTE_PATH,
  BDC_CREDIT_NOTES_PATH,
  BDC_DOCUMENTS_PATH,
  BDC_EDI_PATH,
  BDC_IMPORT_PATH,
  BDC_INVOICES_PATH,
  BDC_QUEUE_PATH,
  BDC_SETTINGS_PATH,
  BDC_SHIPMENT_PATH,
  BDC_STOCK_DAY_PATH,
  BDC_DISPATCH_PATH,
} from "./constants";

/**
 * The whole app for a BDC-only user (bdc manager / bdc operator and no other role).
 *
 * They reach the BDC screens and nothing else. "/" (the GDP dashboard) and every other
 * path redirect to the BDC queue, so a typed-in URL never opens a GDP screen whose calls the
 * server refuses them (ใบวางบิล too — head-office accounting + MASTER only). Which BDC actions they may take inside a screen is still decided by
 * `featureAccess.bdcWrite` there.
 */
export default function BdcOnlyRoutes() {
  return (
    <Routes>
      <Route path={BDC_QUEUE_PATH} element={<BdcQueuePage />} />
      <Route path={BDC_IMPORT_PATH} element={<BdcImportPage />} />
      <Route path={BDC_SHIPMENT_PATH} element={<BdcShipmentPage />} />
      <Route path={BDC_DISPATCH_PATH} element={<BdcDispatchPage />} />
      <Route path={BDC_STOCK_DAY_PATH} element={<BdcStockDayPage />} />
      <Route path={BDC_DOCUMENTS_PATH} element={<BdcDocumentsPage />} />
      <Route path={BDC_INVOICES_PATH} element={<BdcInvoicesPage />} />
      <Route path={BDC_EDI_PATH} element={<BdcEdiPage />} />
      <Route path={BDC_CREDIT_NOTES_PATH} element={<BdcCreditNotesPage />} />
      <Route path={BDC_CREDIT_NOTE_PATH} element={<BdcCreditNotePage />} />
      <Route path={BDC_SETTINGS_PATH} element={<BdcSettingsPage />} />
      <Route path={BDC_DASHBOARD_PATH} element={<BdcDashboardPage />} />
      <Route path={BDC_DASHBOARD_STORES_PATH} element={<BdcDashboardStoresPage />} />
      <Route path="/permission-denied" element={<PermissionDeniedPage />} />
      <Route path="*" element={<Navigate to={BDC_QUEUE_PATH} replace />} />
    </Routes>
  );
}
